import { render, staticRenderFns } from "./TotalWithdrawal.vue?vue&type=template&id=486783bf&scoped=true&"
import script from "./TotalWithdrawal.vue?vue&type=script&lang=js&"
export * from "./TotalWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./TotalWithdrawal.vue?vue&type=style&index=0&id=486783bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486783bf",
  null
  
)

export default component.exports